// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__273ZW","colBig":"styles_colBig__1M8ks","colSmall":"styles_colSmall__1HMK1"};